"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrap = exports.safeDataProxy = void 0;
// Symbol used to uniquely signal a proxy to resolve the original value instead of executing a safe navigation.
var _unwrap = Symbol();
var isPrimitive = function (obj) {
    return typeof obj !== 'object' && typeof obj !== 'function';
};
var safeDataHandler = {
    get: function (target, key) {
        return key in target && typeof target[key] !== 'undefined'
            ? (0, exports.safeDataProxy)(target[key])
            : _undefined;
    },
    set: function () {
        return false;
    },
    has: function (target, key) {
        return key === _unwrap || key in target;
    },
    apply: function (target, thisArg, argumentList) {
        return (0, exports.safeDataProxy)(target.apply(thisArg, argumentList));
    },
    construct: function () {
        return _undefined;
    },
};
var safeDataPrimitiveHandler = {
    get: function (target, key) {
        return key === _unwrap ? function () { return target._value; } : _undefined;
    },
    has: function (_, key) {
        return key === _unwrap || key === '_value';
    },
    set: function () {
        return false;
    },
    apply: function () {
        return _undefined;
    },
    construct: function () {
        return _undefined;
    },
};
// Returns a null-safe proxy wrapping a primitive.
var primitiveProxy = function (value) {
    return new Proxy(Object.seal({ _value: value }), safeDataPrimitiveHandler);
};
// Null-safe singleton that returns itself for every navigation and unwraps to undefined.
var _undefined = primitiveProxy(undefined);
/**
 * @deprecated EXPERIMENTAL: Use with caution; might be changed or dropped in future versions.
 *
 * Makes the given object null-safe, meaning that all navigation on the returned object are safe (will not throw type errors).
 * Note that the returned object will be read-only, so it cannot be altered.
 * Make sure to call {@link unwrap} to obtain any original values.
 *
 * @example
 * const safe = safeDataProxy({ value: 'abc' });
 * unwrap(safe.value); // 'abc'
 * unwrap(safe.some.missing.property); // undefined
 *
 * @param obj The object to make null-safe.
 *
 * @returns The null-safe version of the object.
 *
 */
var safeDataProxy = function (obj) {
    if (obj === _undefined || obj == null) {
        return _undefined;
    }
    return isPrimitive(obj)
        ? primitiveProxy(obj)
        : new Proxy(Object.seal(obj), safeDataHandler);
};
exports.safeDataProxy = safeDataProxy;
/**
 * Unwraps the original value from a null-safe proxy object created by {@link safeDataProxy}.
 * Will return the value itself, if an object other than a null-safe proxy is passed.
 *
 * @param obj The read-only value from a proxy to unwrap.
 *
 * @returns The unwrapped value.
 */
var unwrap = function (obj) {
    if (obj === null || obj === undefined) {
        return obj;
    }
    var unwrap = obj[_unwrap];
    if (!unwrap || typeof unwrap !== 'function') {
        return obj;
    }
    return unwrap.call(obj);
};
exports.unwrap = unwrap;
